import {
  LIST_COURSE_OFFERED_FAILED,
  LIST_COURSE_OFFERED_REQ,
  LIST_COURSE_OFFERED_SUCCESS,
} from "../Constants/courseOffered";
import axiosConfig from "../Core/axiosConfig";

export const STUDENT_LEVEL_LISTS = () => async (dispatch, getState) => {
  try {
    dispatch({ type: LIST_COURSE_OFFERED_REQ });

    let { data } = await axiosConfig.get(`/studylevel`);
    if (data.Result.includes("Error")) {
      dispatch({ type: LIST_COURSE_OFFERED_FAILED, payload: data.Result });
    } else {
      dispatch({ type: LIST_COURSE_OFFERED_SUCCESS, payload: data.Result });
    }
  } catch (ex) {
    dispatch({
      type: LIST_COURSE_OFFERED_FAILED,
      payload: `Error-${ex.message}`,
    });
  }
};
